import AddIcon from "@mui/icons-material/Add";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { Result } from '../../types/Result';
import { cityColumns } from './columns';

export default function CityDataGrid() {
  const data = useLoaderData() as Result<any>;
  const navigate = useNavigate();
  return (
    <>
      <DataGrid
        autoHeight
        sx={{ width: "100%" }}
        rows={data.data}
        getRowId={(row => row.cityCode)}
        columns={cityColumns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        initialState={{
          pagination: { paginationModel: { pageSize: 20 } },
        }}
        pageSizeOptions={[10, 20, 50]}
        disableColumnResize
        density="compact"
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: 'outlined',
                size: 'small',
              },
              columnInputProps: {
                variant: 'outlined',
                size: 'small',
                sx: { mt: 'auto' },
              },
              operatorInputProps: {
                variant: 'outlined',
                size: 'small',
                sx: { mt: 'auto' },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: 'outlined',
                  size: 'small',
                },
              },
            },
          },
        }}
      />
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: 'fixed', bottom: 16, right: 3 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<AddIcon />}
          tooltipTitle={"Yeni"}
          onClick={() => navigate("new")}
        />

      </SpeedDial>
    </>
  );
}